module.exports = __webpack_public_path__ + "img/process-icon-dark.e28b8050.svg";